module.exports = __webpack_public_path__ + "assets/img/10.b7a578c1.png";